@if (timeline) {
    <section class="detail">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-24 col-lg-18">
                    <app-codalt-image
                        [path]="timeline.id + '/' + timeline.image"
                        [thumb]="timeline.image_thumb"
                        [adapt]="timeline.adapt_image"
                        secureType="timeline"
                        class="detail__image">
                    </app-codalt-image>
                    <div class="detail__block pb-0">
                        <h1 class="detail__title">
                            {{ timeline.title }}
                        </h1>
                        <div class="detail__details">
                            <div class="detail__author">
                                {{ timeline?.customer_project?.name }} - {{ timeline.user.name }}
                            </div>
                            <time class="detail__date">
                                {{ timeline.publish_date | date: 'EEEE d MMMM yyyy HH:mm' }}
                            </time>
                        </div>
                        <div class="content">
                            <p [innerHTML]="timeline.content"></p>
                        </div>
                        <div class="item-images">
                            @for (image of timeline.images; track image) {
                                <app-codalt-image
                                    (click)="openImage(image)"
                                    [path]="timeline.id + '/' + image.path"
                                    [adapt]="image.adapt_image"
                                    secureType="timeline"
                                    [thumb]="image.thumb">
                                </app-codalt-image>
                            }
                        </div>
                        @if (timeline.documents?.length) {
                            <div class="item-documents">
                                <b>Bijlage(n): </b>
                                <table>
                                    @for (document of timeline.documents; track document) {
                                        <tr (click)="openDocument(document)">
                                            <td>
                                                <i class="fas fa-file-pdf"></i>
                                            </td>
                                            <td>
                                                {{ document.path }}
                                            </td>
                                        </tr>
                                    }
                                </table>
                            </div>
                        }
                    </div>
                </div>
                @if (timeline.readBy) {
                    <div class="col-24 col-lg-6">
                        <div class="detail__block readby">
                            <h3 class="mb-2">Gelezen ({{ timeline.readBy.length || '0' }})</h3>
                            @for (user of timeline.readBy; track user) {
                                <div>
                                    {{ user.name }}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (Functionalities.TimelineManagement | hasFunctionality) {
            <div class="floating-buttons">
                <button (click)="delete()" color="primary" mat-fab>
                    <mat-icon class="fas fa-trash"></mat-icon>
                </button>
                <button
                    color="primary"
                    mat-fab
                    [routerLink]="
                        customerId
                            ? [
                                  '/',
                                  Routenames.customers,
                                  customerId,
                                  Routenames.projects,
                                  projectId,
                                  Routenames.timeline,
                                  timeline.slug,
                                  Routenames.copy,
                              ]
                            : ['/', Routenames.timeline, timeline.slug, Routenames.copy]
                    ">
                    <mat-icon class="fas fa-copy"></mat-icon>
                </button>
                <button
                    color="primary"
                    mat-fab
                    [routerLink]="
                        customerId
                            ? [
                                  '/',
                                  Routenames.customers,
                                  customerId,
                                  Routenames.projects,
                                  projectId,
                                  Routenames.timeline,
                                  timeline.slug,
                                  Routenames.edit,
                              ]
                            : ['/', Routenames.timeline, timeline.slug, Routenames.edit]
                    ">
                    <mat-icon class="fas fa-pencil-alt"></mat-icon>
                </button>
            </div>
        }
    </section>
}
